module.exports = __webpack_public_path__ + "static/media/And-many.841b92e2.svg";